import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep1Form from '../../components/VoteRegistration/VoteRegistrationStep1Form';

import { PrefixList, SuffixList } from '../../utils/enums';

import { onGoToStep, saveForm, onShowAddressPopup } from './actions';
import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

import { cacheFormData } from '../../utils/formCaching/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../../containers/DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep1 = props => (
    <TransitionContainer
        zIndex={2}
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar
                showChangeLocationLink={false}
                loadRep={true}
                title={'Voter Registration'}
            />
            <FormWrapper>
                <VoteRegistrationStep1Form
                    prefix={props.prefix}
                    suffix={props.suffix}
                    dateOfBirth={props.dateOfBirth}
                    onBack={() => {
                        props.setExitingCardProps(
                            'voteRegistration',
                            props,
                            props.activeAction
                        );

                        props.onShowAddressPopup(true)

                        props.onGoToStep(0, 'back');
                    }}
                    onContinue={() => {
                        props.setExitingCardProps(
                            'voteRegistration',
                            props,
                            props.activeAction
                        );
                        props.onGoToStep(2, 'forward');
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.saveForm(values, []);
                    }}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep1.propTypes = {
    activeAction: PropTypes.object.isRequired,
    prefix: PropTypes.array.isRequired,
    suffix: PropTypes.array.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    dateOfBirth: PropTypes.string,
    saveForm: PropTypes.func,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    onShowAddressPopup: PropTypes.func.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/step1'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            activeAction: state.widget.activeAction,
            address: state.form.google_autocomplete
                ? state.form.google_autocomplete.values.address
                : '',
            prefix: PrefixList,
            suffix: SuffixList,
            dateOfBirth:
                state.voteRegistration.dateOfBirth.day +
                ' ' +
                state.voteRegistration.dateOfBirth.month +
                ' ' +
                state.voteRegistration.dateOfBirth.year,
            isBackTransition: state.voteRegistration.isBackTransition,
            isSubmitting: state.voteRegistration.isSubmitting,
            isMobileResolution: state.widget.isMobileResolution
        };
    },
    { onGoToStep, saveForm, cacheFormData, setExitingCardProps, onShowAddressPopup }
)(VoteRegistrationStep1);
